<a type="button"
  [attr.class]="cssClass"
  [class.disabled]="!enabled"
  (click)="onButtonClick()"><span
    *ngIf="iconClass"
    class="icon-container"><i
      [attr.class]="iconClass"></i></span><span>{{ text | translate}}</span></a>
